module.exports = __webpack_public_path__ + "static/media/Sangath.6b5be891.svg";